<template>
  <div class="baseEdit">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="0">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('customerBalanceAdjust.collapseTitle.basicTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <BasicInfo :canEdit="canEdit" ref="basicInfo" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('customerBalanceAdjust.collapseTitle.detailTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <DetailInfo :canEdit="canEdit" ref="detailInfo" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="this.$route.name.indexOf('Detail') != -1 && showButton"
        type="primary"
        @click="canEdit = !canEdit"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.editToggle') }}</el-button
      >
      <el-button
        v-if="showButton"
        type="primary"
        @click="save()"
        :disabled="!canEdit"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        v-if="this.$route.name.indexOf('Detail') != -1 && showButton"
        type="primary"
        @click="enable()"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.enable') }}</el-button
      >
      <el-button v-if="!showButton" type="primary" @click="cancel()" class="fixed-bottom-btn">{{
        $t('functionBtn.revert')
      }}</el-button>
      <el-button
        v-if="this.$route.name.indexOf('Detail') != -1 && showButton"
        type="primary"
        @click="deleteAdjust()"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import API from '@/api/purchaseSalesCenter/customerBalance/customerBalance';
  import BasicInfo from './components/basicInfo'; // 基本信息
  import DetailInfo from './components/detailInfo'; // 明细
  export default {
    name: 'baseEdit',
    components: {
      BasicInfo, // 基本信息
      DetailInfo, // 明细
    },
    data() {
      return {
        activeNames: ['0', '1'],
        canEdit: true,
        showButton: true,
      };
    },
    mounted() {
      if (this.$route.query.id) {
        this.getDetail();
      }
      if (this.$route.name.indexOf('Detail') != -1) {
        this.canEdit = false;
      }
    },
    methods: {
      importDetail(allDetail) {
        let tableData = allDetail;
        let basicInfo = this.$refs.basicInfo.baseData;
        Object.keys(basicInfo).map((item) => {
          return (basicInfo[item] = tableData[item]);
        });
        basicInfo.customerNo = tableData.detailList[0].partnerCode;
        basicInfo.customerName = tableData.detailList[0].partnerName;
        basicInfo.customer = [
          {
            customerNo: tableData.detailList[0].partnerCode,
            customerName: tableData.detailList[0].partnerName,
          },
        ];
        if (this.$route.name.indexOf('Detail') != -1 && basicInfo.docStatus == '1') {
          this.showButton = false;
        }
        this.$refs.detailInfo.tableData = tableData.detailList;
      },
      async getDetail() {
        // 请求详情
        this.loading.startLoading();
        let params = { id: this.$route.query.id };
        let res = await this.$axios.post(API.QUERY_CUSTOMERBALANCEADJUSTDETAIL, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.importDetail(res.data.data);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async save() {
        // 保存
        let basicInfo = this.$refs.basicInfo.exportChildData();
        let detailInfo = await this.$refs.detailInfo.exportChildData();
        detailInfo.detailList.forEach((element) => {
          (element.partnerCode = basicInfo.customer[0].customerNo),
            (element.partnerName = basicInfo.customer[0].customerName),
            (element.partner_type = basicInfo.customer[0].customerType);
        });
        if (basicInfo && detailInfo) {
          for (let i = 0; i < detailInfo.detailList.length; i++) {
            for (let j = i + 1; j < detailInfo.detailList.length; j++) {
              if (detailInfo.detailList[i].balanceType == detailInfo.detailList[j].balanceType) {
                return this.$message({
                  showClose: true,
                  type: 'error',
                  message: this.$t('customerBalanceAdjust.msg.balanceTypeNoRepeat'),
                });
              }
            }
          }
          let params = this.$baseRequest.assignObj({ ...basicInfo, ...detailInfo });
          this.loading.startLoading();
          let res = await this.$axios.post(API.SAVE_CUSTOMERBALANCEADJUST, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({ showClose: true, type: 'success', message: res.data.msg });
              this.toList();
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          }
        }
      },
      async enable() {
        let params = [this.$route.query.id];
        this.$confirmAction(
          this.$t('customerBalanceAdjust.msg.enableConfirm'),
          this.$t('customerBalanceAdjust.msg.isEnable')
        )
          .then(() => {
            this.commonRequest('INTOEFFECTIVE_CUSTOMERBALANCEADJUST', params);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      async cancel() {
        let params = [this.$route.query.id];
        this.$confirmAction(
          this.$t('customerBalanceAdjust.msg.disableConfirm'),
          this.$t('customerBalanceAdjust.msg.isDisable')
        )
          .then(() => {
            this.commonRequest('CANCEL_CUSTOMERBALANCEADJUST', params);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      async deleteAdjust() {
        let params = [this.$route.query.id];
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.commonRequest('DELETE_CUSTOMERBALANCEADJUST', params);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      commonRequest(apiName, params) {
        this.loading.startLoading();
        this.$axios.post(API[apiName], params).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.toList();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //跳转
      toList() {
        let pathList = {};
        if (this.$route.name.indexOf('Detail') != -1) {
          pathList = {
            fromPath: {
              path: '/customerBalance/adjustmentDetail',
              name: 'adjustmentDetail',
              meta: {
                keepAlive: false,
              },
            },
            toPath: {
              path: '/customerBalance/adjustmentList',
              name: 'adjustmentList',
              meta: {
                keepAlive: false,
                isBack: true,
              },
            },
          };
        } else if (this.$route.name.indexOf('Add') != -1) {
          pathList = {
            fromPath: {
              path: '/customerBalance/adjustmentAdd',
              name: 'adjustmentAdd',
              meta: {
                keepAlive: false,
              },
            },
            toPath: {
              path: '/customerBalance/adjustmentList',
              name: 'adjustmentList',
              meta: {
                keepAlive: false,
                isBack: true,
              },
            },
          };
        } else if (this.$route.name.indexOf('Edit') != -1) {
          pathList = {
            fromPath: {
              path: '/customerBalance/adjustmentEdit',
              name: 'adjustmentEdit',
              meta: {
                keepAlive: false,
              },
            },
            toPath: {
              path: '/customerBalance/adjustmentList',
              name: 'adjustmentList',
              meta: {
                keepAlive: false,
                isBack: true,
              },
            },
          };
        }
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
